<template>
  <div class="row px-lg-3 ps-xl-6 ps-xxl-10 mx-2">
    <div class="col-12 border-top border-light-blue border-1">
    </div>
  </div>
  <div class="row">
    <div class="col-lg-7 col-xl-8 col-xxl-9">
      <div v-if="publications.length == 0">
        <div class="row publication-filter-list px-3 ps-xl-10 g-0">
          <div class="d-flex align-items-lg-center border-bottom border-light-blue border-1 mb-3 mb-lg-0">
            <i class="fa-solid fa-list-ul publication-title-icon"></i><span class="h2 ms-3">Publications by {{ authorName }}</span>
          </div>
          <div class="col-12 mb-5 px-0 pb-5">
            <p>There are no publications for the current team member.</p>
          </div>
        </div>
      </div>
      <div class="row publication-row publication-filter-list px-lg-3 ps-xl-6 ps-xxl-10 g-0 pt-lg-2" v-else>
        <div class="d-flex align-items-lg-center border-bottom border-light-blue border-1 mb-3 mb-lg-0">
          <i class="fa-solid fa-list-ul publication-title-icon"></i><span class="h2 ms-3">Publications by {{ authorName }}</span>
        </div>
        <div class="col-12 mb-5 px-0 pb-5 border-bottom border-light border-1 pt-lg-3 d-block" v-for="(publication, index) in publicationsLoaded">
          <publication-card :publication="publication" />
        </div>
        <div class="col-12 pt-4 pt-lg-6" v-if="publications.length >= toShow">
          <button @click="showMore($event)" class="btn btn-outline-primary show-more" aria-label="load More Items">Load More</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import { reactive, onUpdated } from 'vue';
  import PublicationCard from './PublicationCard';

  export default {
    name: 'PublicationList',
    props: {
      publications: {
        type: Array,
        required: true
      },
      filters: {
        type: Array,
        default: []
      }
    },
    components: {
      PublicationCard
    },
    computed: {
      publicationsLoaded() {
        return this.publications.sort(function (a, b) {
          return new Date(b.OriginalPublicationDate) - new Date(a.OriginalPublicationDate);
        }).slice(0, this.publications.length);
      },
    },
    setup() {
      const urlParams = new URLSearchParams(window.location.search);
      const authorName = urlParams.get('Author');
      const toShow = 7;
      const title = document.querySelector('.publication-title');

      const showMore = (button) => {
        const hiddenItems = document.querySelectorAll('.border-light.border-1.d-none');

        Array.from(hiddenItems, (element, index) => {
          if (toShow >= (index + 1))
            element.classList.remove('d-none'), element.classList.add('d-block');
        });
        document.querySelectorAll('.border-light.border-1.d-none').length === 0 ? button.target.classList.add('d-none') : false;

        const length = document.querySelectorAll('.border-light.border-1.d-block').length;
        const visibleitems = document.querySelectorAll('.border-light.border-1.d-block');

        Array.from(visibleitems, (element, index) => {
          if (length === (index + 1))
            element.classList.remove('border-bottom');
          else
            element.classList.add('border-bottom');
        });
      };

      onUpdated(() => {
        const items = document.querySelectorAll('.border-light.border-1');
        const button = document.querySelector('.show-more');
        const column = document.querySelector('.publication-filter-list');
        const updatedTitle = document.querySelector('.publication-title');

        Array.from(items, (element, index) => {
          if (toShow < (index + 1))
            element.classList.remove('d-block'), element.classList.add('d-none');
          else
            element.classList.add('d-block');
        });

        if (button != null)
          document.querySelectorAll('.border-bottom.border-light.border-1.d-none').length === 0 ? button.classList.add('d-none') : button.classList.remove('d-none');

        const length = document.querySelectorAll('.border-light.border-1.d-block').length;
        const visibleitems = document.querySelectorAll('.border-light.border-1.d-block');

        Array.from(visibleitems, (element, index) => {
          if (length === (index + 1))
            element.classList.remove('border-bottom');
        });
        
        if (updatedTitle == null && title != null) {
          column.prepend(title);
        }

      });

      return {
        toShow,
        showMore,
        authorName
      };
    },
  };
</script>

`
